// removed by extract-text-webpack-plugin
module.exports = {"langDropdown":"LanguageDropdown__langDropdown","fadeIn":"LanguageDropdown__fadeIn","caret":"LanguageDropdown__caret","hidden":"LanguageDropdown__hidden","growDotQello":"LanguageDropdown__growDotQello","growDotBlue":"LanguageDropdown__growDotBlue","growDotGolden":"LanguageDropdown__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LanguageDropdown/LanguageDropdown.scss
// module id = 1856
// module chunks = 0